// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"32f01ccd","488":"13b00b24"}[chunkId] + ".chunk.js";
};